module.exports = __webpack_public_path__ + "static/img/fgbg1-5.c67d12a.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/fgbg1-5.png
// module id = 183
// module chunks = 0